// Context.js
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const MiContexto = createContext();

const ContextProvider = ({ children }) => {
  const [miValor, setMiValor] = useState(null);

  // Referencia estable: no cambia entre renders, evita re-renders en masa de todos los consumidores
  const setValor = useCallback((nuevoValor) => {
    setMiValor(nuevoValor);
  }, []);

  // Objeto de contexto estable: sólo cambia cuando miValor realmente cambia
  const value = useMemo(() => ({ miValor, setValor }), [miValor, setValor]);

  return (
    <MiContexto.Provider value={value}>
      {children}
    </MiContexto.Provider>
  );
};

const useMiContexto = () => {
  return useContext(MiContexto);
};

export { ContextProvider, useMiContexto };
